<template>
    <el-dialog title="标签" width="20%" :visible.sync="dialogVisible" :show-close="false" :destroy-on-close="true">
      <el-form :model="tagInfo" ref="tagForm" :rules="rules" size="small">
        <el-form-item label="编码" :inline="true" prop="code">
          <el-input v-model="tagInfo.code" :disabled="tagInfo.disabledCode" placeholder="请输入编码" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称" :inline="true" prop="name">
          <el-input v-model="tagInfo.name" placeholder="请输入名称" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" :inline="true" prop="status">
          <el-select v-model="tagInfo.status" placeholder="请选择状态" style="width:100%">
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog()">取 消</el-button>
        <el-button size="small" @click="saveTagFunc()" type="primary">确 定</el-button>
      </div>
    </el-dialog>    
</template>

<script>
import { Message,MessageBox } from 'element-ui';
import { saveTag,findTags,deleteTag } from "@/api/dict";

export default {
  name: "EditTagDialog",
  props: {
    dialogVisible: false,
    tagInfo : {
        id: '',
        name:'',
        code:'',
        status:'',
        disabledCode: false
    },
  },
  data(){
    return {
      rules: {
          code: [
            { required: true, message: "请输入编码", trigger: "blur" },
          ],
          name: [
            { required: true, message: "请输入名称", trigger: "blur" },
          ],
          status: [
            { required: true, message: "请选择状态", trigger: "blur" },
          ],
      },
      loading:false,
    }
  },
  mounted(){
    
  },
  created() {
     
  },
  watch : {
    
  },
  methods: {
    
    //打开新增用户弹窗
    closeDialog(){
      this.$emit('closeTagDialog');
    },

    //保存标签
    saveTagFunc() {
      var _this = this;
      this.$refs.tagForm.validate((valid) => {
          if(valid){
             let param = _this.tagInfo;
             saveTag(param).then(res => {
                if(res.code == 200){
                    Message.success('保存成功');
                    _this.$emit('closeTagDialog');
                } else {
                    Message.error(res.msg);
                }
             }); 
          }
      });
    },
    

    
    
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/dialog/EditTagDialog.vue